(function() {

  'use strict';



  function pxChangeDriverConfig($filter, $rootScope, WorkstationListPaging, WorkstationListService) {
    return {
      restrict: 'EA',
      scope: {
        changeDriverConfigData: '=changeDriverConfigData',
        callback: '&callback'
      },
      templateUrl: 'app/components/printQueueProperties/driverConfig/changeDriverConfig/change-driver-config.template.html',
      link: function(scope) {


        scope.printer = scope.changeDriverConfigData.printer;
        scope.workstationTypeList = [
          {
            name: "DESKTOP",
            id: "DESKTOP",
            selectDisabled: false,
            type: 'value'
          },
          {
            name: "LAPTOP",
            id: "LAPTOP",
            selectDisabled: false,
            type: 'value'
          },
          {
            name: "SERVER",
            id: "SERVER",
            selectDisabled: false,
            type: 'value'
          },
          {
            name: '------------',
            id: null,
            selectDisabled: true,
            type: 'breaker'
          },
          {
            name: 'ClearFilter',
            id: null,
            selectDisabled: false,
            type: 'clearFilter'
          }
        ];

        var emptyListItem = {
          name: '',
          warning: true,
          selectDisabled: true
        };

        scope.driverConfigItem = {
          boolean: false,
          driverConfigObject: null
        };

        scope.copyOfDriverConfigName = '';
        scope.workstationsForSystemAndUser = new WorkstationListPaging();
        scope.workstationsForSystemAndUserSelectList = new WorkstationListPaging();

        scope.networkPairingInvalid = false;

        scope.wsPaginationObject = null;

        (function() {
          init();
        })();

        scope.$watch(function () {
          return scope.changeDriverConfigData;
        }, function() {
          init();
        });

        function init() {
          setDriverConfigObject();
          translateListItems();
          getWorkstations();
          copyDriverConfigName();
        }

        function setDriverConfigObject () {
          scope.driverConfigItem.driverConfigObject = {
            workstation: null,
            name: scope.changeDriverConfigData.name ? scope.changeDriverConfigData.name : '',
            os: scope.changeDriverConfigData.os,
            id: scope.changeDriverConfigData.driverConfig,
            onlyUploadConfiguration: scope.changeDriverConfigData.os.key === 'MAC_OS' || scope.printer.info.type === 'FREEDOM' ? true : false
          }
        }

        function translateListItems() {
          for (var i = 0; i < scope.workstationTypeList.length; i++) {
            if (scope.workstationTypeList[i].type !== 'breaker') {
              scope.workstationTypeList[i].name = $filter('translate')(scope.workstationTypeList[i].name);
            }
          }

          emptyListItem.name = $filter('translate')('NoSearchResultComputer');
        }

        function privateEvaluateCreateConfigForm () {
          if (evaluateConfigName() && scope.driverConfigItem.driverConfigObject.workstation) {
            scope.callback({item: scope.driverConfigItem, boolean: true})
          } else {
            scope.callback({item: scope.driverConfigItem, boolean: false})
          }
        }

        scope.selectComputerPaginated = function () {
          scope.driverConfigItem.driverConfigObject.workstation = null;
          privateEvaluateCreateConfigForm();
          scope.workstationsForSystemAndUserSelectList.pagingCriteria.pageSize = 10;
          scope.workstationsForSystemAndUserSelectList.pagingCriteria.systems = checkOsKey(scope.changeDriverConfigData.os.key);
          scope.workstationsForSystemAndUserSelectList.pagingCriteria.active = true;
          scope.workstationsForSystemAndUserSelectList.pagingCriteria.types = scope.filterType ? scope.filterType : null;
          scope.workstationsForSystemAndUserSelectList.pagingCriteria.wppEnabled = false;

          if (scope.driverConfigItem.driverConfigObject.onlyUploadConfiguration) {
            scope.workstationsForSystemAndUserSelectList.pagingCriteria.user = null;
            scope.workstationsForSystemAndUserSelectList.pagingCriteria.queueFilterMode = 'PRESENT';
            scope.workstationsForSystemAndUserSelectList.pagingCriteria.queue = scope.changeDriverConfigData.printQueue.info._links.self.href;
            scope.workstationsForSystemAndUserSelectList.pagingCriteria.networks = null;
          } else {
            scope.workstationsForSystemAndUserSelectList.pagingCriteria.user = $rootScope.currentUser.info._links.self.href;
            scope.workstationsForSystemAndUserSelectList.pagingCriteria.queueFilterMode = null;
            scope.workstationsForSystemAndUserSelectList.pagingCriteria.queue = null;
            if (scope.changeDriverConfigData.printer.info.type !== 'FREEDOM') {
              scope.workstationsForSystemAndUserSelectList.pagingCriteria.networks = scope.printer.info._links['px:network'].href;
            }
          }

          if (scope.workstationsForSystemAndUserSelectList.pagingCriteria.systems === 'MAC_OS') {
            scope.workstationsForSystemAndUserSelectList.pagingCriteria.systems = 'MAC'
          }

          scope.wsPaginationObject = scope.workstationsForSystemAndUserSelectList
        }

        function checkOsKey (osKey) {
          switch(osKey) {
            case 'WIN_10_64':
              return 'WIN_10_64,WIN_11_64'
            case 'WIN_2016_64':
              return 'WIN_2016_64,WIN_2019_64,WIN_2022_64'
            default:
              return osKey
          }
        }

        function getWorkstations () {
          scope.driverConfigItem.driverConfigObject.workstation = null;
          privateEvaluateCreateConfigForm();
          scope.gettingWorkstations = true;
          scope.list = [];
          scope.workstationsForSystemAndUser.pagingCriteria.systems = checkOsKey(scope.changeDriverConfigData.os.key);
          scope.workstationsForSystemAndUser.pagingCriteria.active = true;
          scope.workstationsForSystemAndUser.pagingCriteria.types = scope.filterType ? scope.filterType : null;
          scope.workstationsForSystemAndUser.pagingCriteria.wppEnabled = false;

          if (scope.driverConfigItem.driverConfigObject.onlyUploadConfiguration) {
            scope.workstationsForSystemAndUser.pagingCriteria.user = null;
            scope.workstationsForSystemAndUser.pagingCriteria.queueFilterMode = 'PRESENT';
            scope.workstationsForSystemAndUser.pagingCriteria.queue = scope.changeDriverConfigData.printQueue.info._links.self.href;
            scope.workstationsForSystemAndUser.pagingCriteria.networks = null;
          } else {
            scope.workstationsForSystemAndUser.pagingCriteria.user = $rootScope.currentUser.info._links.self.href;
            scope.workstationsForSystemAndUser.pagingCriteria.queueFilterMode = null;
            scope.workstationsForSystemAndUser.pagingCriteria.queue = null;
            if (scope.changeDriverConfigData.printer.info.type !== 'FREEDOM') {
              scope.workstationsForSystemAndUser.pagingCriteria.networks = scope.printer.info._links['px:network'].href;
            }
          }

          if (scope.workstationsForSystemAndUser.pagingCriteria.systems === 'MAC_OS') {
            scope.workstationsForSystemAndUser.pagingCriteria.systems = 'MAC'
          }

          WorkstationListService.getWorkstationListPaged(scope.workstationsForSystemAndUser).then(function (response) {
            scope.gettingWorkstations = false;
            scope.changeDriverConfigData.workstations = response.list;
            if (scope.changeDriverConfigData.workstations.length > 0) {
              checkForEligibleWorkstations();
            } else {
              if (scope.list.length === 0) {
                scope.list.push(emptyListItem);
              }
            }
          }).catch(function(error) {
            scope.gettingWorkstations = false;
          });
        }

        function copyDriverConfigName () {
          scope.copyOfDriverConfigName = scope.changeDriverConfigData.name ? angular.copy(scope.changeDriverConfigData.name) : '';
        }

        function checkForEligibleWorkstations() {
          var users = $filter('stringular')($filter('translate')('Users'));
          var user = $filter('stringular')($filter('translate')('USER'));
          var eligbleComputers = [];
          var nonEligbleComputers = [];

          // MARK DISABLED, IF MORE THAN USER IS LOGGED IN AND ADD USERS TO NAME
          for (var i = 0; i < scope.changeDriverConfigData.workstations.length; i++) {
            if (scope.changeDriverConfigData.workstations[i].info.userIds.length > 1 && !scope.driverConfigItem.driverConfigObject.onlyUploadConfiguration) {
              scope.changeDriverConfigData.workstations[i].info.selectDisabled = true;
              scope.changeDriverConfigData.workstations[i].info.dimmed = true;
              scope.changeDriverConfigData.workstations[i].info.name += ' (' + users + ': ' + scope.changeDriverConfigData.workstations[i].info.userIds.length + ')';
            } else if (scope.changeDriverConfigData.workstations[i].info.userIds.length > 1 && scope.driverConfigItem.driverConfigObject.onlyUploadConfiguration) {
              scope.changeDriverConfigData.workstations[i].info.name += ' (' + users + ': ' + scope.changeDriverConfigData.workstations[i].info.userIds.length + ')';
            } else {
              scope.changeDriverConfigData.workstations[i].info.name += ' (' + user + ': 1)'
            }
          }

          // SPLIT WORKSTATIONS INTO TWO ARRAYS
          for (var i = 0; i < scope.changeDriverConfigData.workstations.length; i++) {
            if (scope.changeDriverConfigData.workstations[i].info.selectDisabled) {
              nonEligbleComputers.push(scope.changeDriverConfigData.workstations[i].info)
            } else {
              eligbleComputers.push(scope.changeDriverConfigData.workstations[i].info);
            }
          }

          var breaker = {
            name: '--------------------',
            break: true,
            selectDisabled: true,
            id: null
          }

          if (eligbleComputers.length  && nonEligbleComputers.length) {
            eligbleComputers.push(breaker);
            scope.list = eligbleComputers.concat(nonEligbleComputers);
          } else if (!eligbleComputers.length && nonEligbleComputers.length) {
            eligbleComputers = setWarning(eligbleComputers);
            eligbleComputers.push(breaker);
            scope.list = eligbleComputers.concat(nonEligbleComputers);
          } else if (eligbleComputers.length && !nonEligbleComputers.length) {
            scope.list = eligbleComputers;
          }
        };

        function setWarning (eligbleComputers) {
          var message = $filter('stringular')($filter('translate')('YouAndOnlyYouMustBeSignedInToTheComputer'));
          if (eligbleComputers.length === 0 && !scope.driverConfigItem.driverConfigObject.onlyUploadConfiguration) {
            var warning = {
              warning: true,
              selectDisabled: true,
              id: null,
              name: message
            }
            eligbleComputers.push(warning);
          }
          return eligbleComputers;
        };

        scope.setFocus = function (){
          angular.element('.configuration-name').focus();
          return true;
        };


        scope.selectWorkstation = function (selectedWorkstation) {
          // checkForEligibleWorkstations();
          if (selectedWorkstation) {
            scope.driverConfigItem.driverConfigObject.workstation = selectedWorkstation.info;
          } else {
            scope.driverConfigItem.driverConfigObject.workstation = null;
          }

          scope.evaluateCreateConfigForm();
          scope.wsPaginationObject = null;
        }

        scope.changeTypeFilter = function(filterType) {
          scope.filterType = filterType.id;
          getWorkstations();
        }

        function evaluateConfigName () {
          if (scope.driverConfigItem.driverConfigObject.name.length > 0 && scope.driverConfigItem.driverConfigObject.name.length !== scope.copyOfDriverConfigName) {
            return true
          } else {
            return false
          }
        }

        scope.evaluateCreateConfigForm = function(){
          if (evaluateConfigName() && scope.driverConfigItem.driverConfigObject.workstation) {
            scope.callback({item: scope.driverConfigItem, boolean: true})
          } else {
            scope.callback({item: scope.driverConfigItem, boolean: false})
          }
        }

        scope.changeOnlyUploadConfiguration = function () {
          getWorkstations();
        }

        scope.getClient = function(){
          return $rootScope.clientNameValue;
        }

        scope.getOs = function () {
          var osNameValue = scope.changeDriverConfigData.os.value;
          if (osNameValue === 'macOs') {
            osNameValue = 'macOS'
          }

          return osNameValue;
        }

        $rootScope.$watch("currentUser.info._embedded.user.language", function() {
          translateListItems();
        });

      }
    };
  };

  pxChangeDriverConfig.$inject = ['$filter', '$rootScope', 'WorkstationListPaging', 'WorkstationListService'];

  angular
    .module('printix-admin')
    .directive('pxChangeDriverConfig', pxChangeDriverConfig);

})();